import React from 'react';
import { Search, ListChecks, Scale } from 'lucide-react';
import { SectionHead } from './SectionHead';

const STEPS = [
  { icon: Search, title: 'Search a ticker', desc: 'Pick a horizon (from 1 day to 1 year) and a strategy: momentum, mean reversion or options flow.' },
  { icon: ListChecks, title: 'Review the evidence', desc: 'Read the score, probability, drivers, key levels and risks next to the chart, plus the written thesis.' },
  { icon: Scale, title: 'Decide for yourself', desc: 'Use it as one input to your own research. Every outlook is saved with a timestamp and graded later.' },
];

export const HowItWorks = () => (
  <section className="mk-section" id="how-it-works" aria-labelledby="how-title">
    <div className="mk-container">
      <SectionHead id="how-title" eyebrow="How it works" title="Three steps, no guesswork about where numbers come from" />
      <ol className="mk-steps">
        {STEPS.map((s, i) => (
          <li key={s.title} className="mk-card mk-step" data-testid="how-step">
            <span className="mk-step-n mk-num" aria-hidden="true">{String(i + 1).padStart(2, '0')}</span>
            <s.icon size={20} aria-hidden="true" className="mk-step-ic" />
            <h3>{s.title}</h3>
            <p>{s.desc}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
